import { render, staticRenderFns } from "./ChatAi.vue?vue&type=template&id=25f1aff2"
import script from "./ChatAi.vue?vue&type=script&lang=js"
export * from "./ChatAi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports